getLocation